import { CardLoader, ListPagination } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import ConsignmentInboundRequestTableRow from './consignment-inbound-request-table-row'
import { CONSIGNMENT_INBOUND_REQUEST_COLUMNS, SELLER_COLUMNS } from './consignment-inbound-request-table-columns'

const propTypes = {
  tableProps      : PropTypes.object,
  inboundRequests : PropTypes.array,
  pagination      : PropTypes.object,
  onPageChange    : PropTypes.func,
  isLoading       : PropTypes.bool,
  onClickRow      : PropTypes.func,
  hiddenColumns   : PropTypes.array,
  actionButtons   : PropTypes.array
}

const defaultProps = {
  isLoading     : true,
  onPageChange  : () => { },
  hiddenColumns : [],
  actionButtons : []
}

/**
 * Table to display specific ::Consignment::InboundRequest data
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} inboundRequests - array of Consignment::InboundRequest
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Boolean} isLoading - boolean for withLoader animation
 * @param {Function} onPageChange - function that will handle page change
 * @param {Function} onClickRow - function that trigger when user click row data
 * @param {Array<String>} hiddenColumns - Array of hidden columns name
 */
const ConsignmentInboundRequestTable = ({
  tableProps,
  inboundRequests,
  pagination,
  isLoading,
  onPageChange,
  onClickRow,
  hiddenColumns
}) => {

  const inboundRequestColumns = CONSIGNMENT_INBOUND_REQUEST_COLUMNS.filter((column) => !hiddenColumns.includes(column.name))
  const sellerColumns         = SELLER_COLUMNS.filter((column) => !hiddenColumns.includes(column.name))

  const consignmentInboundRequestHeaderLength = inboundRequestColumns.length
  const sellerHeaderLength                    = sellerColumns.length

  const totalColumns    = consignmentInboundRequestHeaderLength + sellerHeaderLength
  const isInboundsEmpty = inboundRequests.length === 0

  const TableContent = () => (
    <>
      <Table { ...tableProps }>
        <thead>
          <tr>
            {
              consignmentInboundRequestHeaderLength > 0 && (
                <th colSpan={ consignmentInboundRequestHeaderLength } className='text-center'>
                  { 'Consignment Inbound Request' }
                </th>
              )
            }
            {
              sellerHeaderLength > 0 && (
                <th colSpan={ sellerHeaderLength } className='text-center'>
                  { 'Seller' }
                </th>
              )
            }
          </tr>
        </thead>
        <thead>
          <tr>
            {
              inboundRequestColumns.map((column) => (
                <th key={ `inbound-column-${column.name}` } scope="col">{ column.label }</th>
              ))
            }
            {
              sellerColumns.map((column) => (
                <th key={ `inbound-column-${column.name}` } scope="col">{ column.label }</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            inboundRequests.map((inboundRequestData) => (
              <ConsignmentInboundRequestTableRow
                key={ `consignment-inbound-request-data-${inboundRequestData.id}` }
                inboundRequest={ inboundRequestData }
                onClickRow={ onClickRow }
                hiddenColumns={ hiddenColumns }
                inboundRequestColumns={ inboundRequestColumns }
                sellerColumns={ sellerColumns }
              />
            ))
          }
          {
            isInboundsEmpty && (
              <tr>
                <td
                  colSpan={ totalColumns }
                  className='bg-warning text-white'
                >
                  <i className='fas fa-info-circle mr-3' />
                  { 'Consignment Inbound Request tidak ditemukan.' }
                </td>
              </tr>
            )
          }
        </tbody>
      </Table>
    </>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


ConsignmentInboundRequestTable.propTypes    = propTypes
ConsignmentInboundRequestTable.defaultProps = defaultProps

export default ConsignmentInboundRequestTable